// extracted by mini-css-extract-plugin
export default {"spoilerBlock":"Collapsed_spoilerBlock__Zyktf","spoilerBtn":"Collapsed_spoilerBtn__bHl9d","expanded":"Collapsed_expanded__g0ZLI","spoilerContent":"Collapsed_spoilerContent__0LeDE"};